import { Injectable } from '@angular/core';

import { DataService } from '../data.service';
import { SimpleRepository } from './_simple.repository';
import { IGetallDTO } from 'src/app/model/dto/getall.dto';
import { Cat } from 'src/app/model/orm/cat.model';

@Injectable()
export class CatsRepository extends SimpleRepository<Cat> {
    constructor(protected dataService: DataService) {
        super();
        this.sortBy = "pos";
    }
    
    public load(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (new Date().getTime() - this.loadedAt < this.ttl) {
                resolve();
            } else {
                const dto: IGetallDTO = {sortBy: this.sortBy, sortDir: this.sortDir};
                this.dataService.catsAll(dto).subscribe(res => {                                                            
                    if (res.statusCode === 200) {
                        this.build(res.data);
                        this.loadedAt = new Date().getTime();
                        resolve();
                    } else {                        
                        reject(res.statusCode+": "+res.error);
                    }
                }, err => {
                    reject(err.message);
                });
            }            
        });
    }    

    public build(cats: Array<Cat> = []): void {
        this.xl = cats.length ? cats.map(d => new Cat().build(d)) : [];
    }
}
